import * as yup from 'yup';

export const formikSchema = yup.object().shape({
    firstName: yup.string().required('Please enter your first name'),
    lastName: yup.string().required('Please enter your last name'),
    email: yup.string().email('Email must be valid').required('Please enter your email'),
    comments: yup.string().required('Please enter your comments'),

})